import { callApi, LONG_API_TIMEOUT_MS } from './ApiClient';

const multipartFormOptions = {
  withCredentials: true,
  headers: { 'Content-Type': 'multipart/form-data' },
  baseURL: process.env.REACT_APP_API_BASE_URL,
};

const postLetterOrdersOrder = (data, dispatch) => {
  // 注文APIはファイルのS3アップロードや関連レコード作成を同期的に実行するため時間がかかる
  return callApi('POST', '/letter-orders/order', data, dispatch, false, {
    timeout: LONG_API_TIMEOUT_MS,
  });
}

const getLetterOrders = (data, dispatch) => {
  // 注文一覧はサーバー側でもset_time_limit(600)されている重いAPIのため長めに設定する
  return callApi('GET', '/letter-orders', data, dispatch, false, {
    timeout: LONG_API_TIMEOUT_MS,
  });
}

const getLetterOrdersAddresses = (id, data, dispatch) => {
  return callApi('GET', `/letter-orders/${id}/addresses`, data, dispatch);
}

const postLetterOrdersSalesforceSync = (data, dispatch) => {
  return callApi('POST', `/letter-orders/salesforce/sync`, data, dispatch);
}

const getLetterOrdersLetterContentCheck = (data, dispatch) => {
  return callApi('GET', `/letter-orders/letter-content/check`, data, dispatch);
}

const postLetterOrdersAdditionalFileValidate = (data, dispatch) => {
  return callApi('POST', '/letter-orders/additional-file/validate', data, dispatch, false, multipartFormOptions);
}

export const LetterOrdersApi = {
  postLetterOrdersOrder,
  getLetterOrders,
  getLetterOrdersAddresses,
  postLetterOrdersSalesforceSync,
  getLetterOrdersLetterContentCheck,
  postLetterOrdersAdditionalFileValidate,
};



// WEBPACK FOOTER //
// ./src/redux/api/LetterOrdersApi.js